import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { StiiraError } from '@core/models';
import { AuthService, ErrorService, LayoutService, ProfileService, SnackbarService } from '@core/services';
import { position, onDragEnded } from '@shared/helpers/dialog-drag-constraints';
import { indicate } from '@shared/helpers/rxjs.helpers';
import { Observable, Subject } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { closeDialogOnEscape } from '@shared/helpers';

@Component({
    selector: 'app-change-username',
    templateUrl: './change-username.component.html',
    styleUrls: ['./change-username.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ChangeUsernameComponent implements OnInit {
  static readonly componentName = 'ChangeUsernameComponent';
  
  public position = position;
  public onDragEnded = onDragEnded;

  form: UntypedFormGroup;
  hidePassword = true;
  isSubmitting$ = new Subject<boolean>();
  public isMobile$: Observable<boolean>;

  get password(): FormControl {
    return this.form.get('password') as FormControl;
  }

  get username(): FormControl {
    return this.form.get('username') as FormControl;
  }

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<ChangeUsernameComponent>,
    private profileService: ProfileService,
    private authService: AuthService,
    private snackbarService: SnackbarService,
    private errorService: ErrorService,
    @Inject(MAT_DIALOG_DATA) public sysText,
    private layoutService: LayoutService
  ) { }

  ngOnInit() {
    this.isMobile$ = this.layoutService.isMobile$();
    closeDialogOnEscape(this.dialogRef, this.isSubmitting$, () => this.dialogRef.close());

    this.form = this.fb.group({
      password: ['', Validators.required],
      username: ['', Validators.required]
    });
  }

  changeUsername(): void {
    this.profileService
      .changeUsername({password: this.form.value.password, username: this.form.value.username})
      .pipe(
        indicate(this.isSubmitting$),
        finalize(() => { })
      )
      .subscribe(
        () => {
          this.snackbarService.open('Username successfully changed', 'Dismiss');
          this.authService.logout();
          this.dialogRef.close();
        },
        (err: StiiraError) => {
          this.errorService.setFormModelStateErrors(this.form, err.modelStateErrors);
        }
      );
  }
}
